// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3eb2Q","info":"Note_info__1Dy8A","note":"Note_note__r4tqJ","actions":"Note_actions__35gju"};